module.exports = __webpack_public_path__ + "img/ESPANHOL.997c6499.png";